var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('login',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isRegister),expression:"!isRegister"}],on:{"register":function($event){_vm.isRegister = true}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }